<template>
    <a-drawer :title="dataInfo.name" :visible="visible" :width="width" placement="right" @close="handleClose">
        <div class="title strong mb20">{{ $t('goods.activity_info') }}</div>
        <!-- 活动信息 -->
        <a-row :gutter="[10, 10]">
            <a-col :xs="24" :sm="12">
                {{ $t('goods.activity_name') }}：{{ dataInfo.name }}
                <!-- 活动名称 -->
            </a-col>
            <a-col :xs="24" :sm="12">
                {{ $t('goods.promotion_status') }}：
                <!--status == 0 ？暂停 ：进行中-->
                <!-- 促销状态 -->
                <a-tag color="green" v-if="dataInfo.status == 1">{{ $t('goods.in_progress') }}</a-tag>
                <!-- 进行中 -->
                <a-tag color="red" v-if="dataInfo.status == 0">{{ $t('goods.paused') }}</a-tag>
                <!-- 已暂停 -->
            </a-col>
            <a-col :xs="24" :sm="14">
                {{ $t('goods.start_end_time') }}：{{ dataInfo.start_time }} ~ {{ dataInfo.end_time }}
                <!-- 起止时间 -->
            </a-col>
        </a-row>

        <div class="title strong mb20 mt20">{{ $t('goods.ticket_info') }}</div>
        <!-- 门票信息 -->
        <a-table ref="table" :rowKey="record => record.id" :columns="columns" :data-source="dataInfo.goods" :pagination="false" class="mt15" size="middle" :scroll="{ x: 800 }">
            <span slot="index" slot-scope="text, record, index">
                {{ index + 1 }}
            </span>
            <span slot="status" slot-scope="text">
                <a-badge :status="text | statusTypeFilter" :text="text | statusFilter" />
            </span>

            <span slot="inventory" slot-scope="text, record">
                {{ record.is_limit == 0 ? $t('goods.unlimited') : text }}
                <!-- 不限 -->
            </span>

            <span slot="action" slot-scope="text, record">
                {{ record.promo_price }} {{ $t('goods.yuan') }}
                <!-- 元 -->
            </span>
        </a-table>
    </a-drawer>
</template>

<script>
export default {
    name: 'LadderInfo',
    props: {
        dataInfo: {
            type: Object,
            default: () => {}
        },
        width: {
            type: Number,
            default: 800
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            columns: [
                // 表格列配置
                {
                    title: this.$t('goods.index'), // 序号
                    dataIndex: 'index',
                    align: 'center',
                    scopedSlots: { customRender: 'index' }
                },
                {
                    title: this.$t('goods.ticket_name'), // 门票名称
                    dataIndex: 'name',
                    align: 'center'
                },
                {
                    title: this.$t('goods.price'), // 单价
                    dataIndex: 'price',
                    align: 'align'
                },
                {
                    title: this.$t('goods.ticket_num'), // 门票编号
                    dataIndex: 'number',
                    align: 'align'
                },
                {
                    title: this.$t('goods.inventory'), // 库存
                    dataIndex: 'inventory',
                    align: 'center',
                    scopedSlots: { customRender: 'inventory' }
                },
                {
                    title: this.$t('goods.discounted_price'), // 优惠后价格
                    dataIndex: 'action',
                    align: 'center',
                    scopedSlots: { customRender: 'action' }
                }
            ],
            dataSource: []
        };
    },
    methods: {
        handleClose() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped lang="less"></style>
